import {
  ExtendedTypography,
  GridEmptyState,
} from '@issuemanager/apps/client/components';
import { paths } from '@issuemanager/apps/client/paths';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Link as MUILink } from '@mui/material';
import { Stack } from '@mui/system';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function IssuesEmptyState() {
  const semantic = useAtlasSemanticThemeTokens();

  const { t } = useTranslation(['common']);

  return (
    <GridEmptyState>
      <Stack
        direction='column'
        justifyContent='start'
        alignItems='center'
        spacing={1.5}
        height='100%'
        data-testid='issues-empty-state'
      >
        <ExtendedTypography fontWeight='medium'>
          {t('common:table.empty')}
        </ExtendedTypography>
        <ExtendedTypography
          variant='body2'
          color={semantic.color.text.muted.value}
        >
          <Trans
            i18nKey='issue:empty.master.addIssueTransKey'
            components={{
              appLink: (
                <MUILink
                  data-testid='add-issue-link-button'
                  component={Link}
                  sx={{ pointerEvents: 'auto' }}
                  to={`/${paths.issues.create}`}
                />
              ),
            }}
          />
        </ExtendedTypography>
      </Stack>
    </GridEmptyState>
  );
}
